import request from "@/request/confJs/request";
import { API_ENDPOINTS } from "@/config/api";
import { normalizeMediaFields, normalizeMediaList, toStoredFileValue } from "@/utils/fileUrl";

const toSongPayload = (data) => ({
  ...data,
  coverUrl: toStoredFileValue(data?.coverUrl),
  fileUrl: toStoredFileValue(data?.fileUrl),
});

export async function getMusics() {
  const res = await request({ url: API_ENDPOINTS.music.list, method: "GET" });
  return { ...res, data: normalizeMediaList(res.data, ["coverUrl", "fileUrl"]) };
}

export async function addMusic(data) {
  const res = await request({ url: API_ENDPOINTS.music.create, method: "POST", data: toSongPayload(data) });
  return { ...res, data: normalizeMediaFields(res.data, ["coverUrl", "fileUrl"]) };
}

export async function updateMusic(data) {
  const res = await request({ url: API_ENDPOINTS.music.update, method: "POST", data: toSongPayload(data) });
  return { ...res, data: normalizeMediaFields(res.data, ["coverUrl", "fileUrl"]) };
}

export const deleteMusic = (id) =>
  request({ url: API_ENDPOINTS.music.remove, method: "POST", params: { id } });
